import axios from '../../bootstrap';

export function axiosGetCategory() {
    return axios.get('/api/admin/category/ajaxgetcategory');
}

/**
 * @param {{ catname: any; parent: any; }} param
 */
export function axiosSaveCategory(param) {
    return axios.get('/api/admin/category/ajaxsavecategory', { params: param });
}

/**
 * @param {{ arrblog: any[]; }} param
 */
export function axiosEditCategory(param) {
    return axios.get('/api/admin/category/ajaxeditcategory', { params: param });
}

/**
 * @param {{ category_name: any; slug_id: any; }} odjData
 */
export function axiosRenameCategory(odjData) {
    return axios.post('/api/admin/category/ajaxrenamecategory', odjData);
}

/**
 * @param {{ slug_id: any; }} odjData
 */
export function axiosDeleteCategory(odjData) {
    return axios.post('/api/admin/category/ajaxdeletecategory', odjData);
}
